import liff from "@line/liff";

document.querySelector("#close_bth").addEventListener("click", () => {
  liff.closeWindow();
});
